import { Injectable } from '@angular/core';
import { ColumnState, FilterModel } from 'ag-grid-community';
import { ItemsModuleSections } from '../models/items.module';
import { ApplyGridFilterEvent } from 'src/app/shared/components/extended-table/extended-table.component';

export interface GridSavedState {
  filterModel?: FilterModel | null;     // Filtri standard (es. filtro su colonna testo)
  columnState?: ColumnState[];          // Ordine e visibilità colonne
  paginationPage?: number;              // Pagina corrente
  searchBarValue?: string;              // ricerca testuale con search bar
  searchBarcode?: boolean;              // ricerca per barcode 
  //Filtri personalizzati aggiuntivi (item-showcase)
  customAgGridFilters?: ApplyGridFilterEvent | null;
  showExtendedTable?: boolean;
}

@Injectable()
export class GridStateService {

  private states = new Map<ItemsModuleSections, GridSavedState>();

  saveState(key: ItemsModuleSections, state: GridSavedState) {
    this.states.set(key, state);
  }

  getState(key: ItemsModuleSections): GridSavedState | undefined {
    return this.states.get(key);
  }
  
  updateState(key: ItemsModuleSections, partialState: Partial<GridSavedState>) {
    const currentState = this.getState(key) || {} as GridSavedState;
    const newState = { ...currentState, ...partialState };
    this.saveState(key, newState);
}
  
  hasState(key: ItemsModuleSections): boolean {
    return this.states.has(key);
  }

  clearState(key: ItemsModuleSections) { 
    this.states.delete(key); 
  }

  clearAllStates() {
    this.states.clear();
  }
}
